module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [(_vm.isConfirming) ? _c('v-btn', {
    staticClass: "delete-button error",
    class: {
      active: _vm.isConfirming
    },
    nativeOn: {
      "click": function($event) {
        return _vm.raiseDeleteEvent($event)
      }
    }
  }, [_vm._v("Delete")]) : _c('v-btn', {
    staticClass: "delete-button grey--text",
    class: {
      active: !_vm.isConfirming
    },
    attrs: {
      "disabled": _vm.disabled,
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.confirmDelete($event)
      }
    }
  }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02e4eadc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DeleteButton.vue
// module id = 2427
// module chunks = 1